<template>
   <b-row>
      <div class="col-sm-12 mt-3">
         <label for="" class="form-label">Nombre completo</label>
         <input type="text" class="form-control form-control-sm" v-model="nombre">
      </div>
      <div class="col-sm-12 mt-3">
         <label for="" class="form-label">Usuario</label>
         <input type="text" class="form-control form-control-sm" autocomplete="off" v-model="usuario">
      </div>
      <div class="col-sm-6 mt-3">
         <label for="" class="form-label">Contraseña</label>
         <input type="password" class="form-control form-control-sm" v-model="password">
      </div>
      <div class="col-sm-6 mt-3">
         <label for="" class="form-label">Confirmar contraseña</label>
         <input type="password" class="form-control form-control-sm" v-model="confirmar_password">
      </div>
      <div class="col-sm-12 mt-5 mb-3">
         <button v-if="btn_siguiente" type="button" class="btn btn-sm btn-outline-dark btn-block"
            @click="guardar_info">Siguiente</button>
         <button v-else type="button" class="btn btn-sm btn-outline-dark btn-block" disabled>Siguiente</button>
      </div>
   </b-row>
</template>

<script>
   import { atexto, minix } from '@/components/functions/alertas';
   import moment from 'moment';
   import { mapMutations, mapState } from 'vuex';

   export default {
      name: 'DatosPrincipales',
      computed: {
         ...mapState(['objeto_usuario'])
      },
      data() {
         return {
            nombre: '',
            usuario: '',
            password: '',
            confirmar_password: '',
            btn_siguiente: false,
         }
      },
      methods: {
         validarCampos() {
            if (this.nombre.trim() !== '' &&
               this.usuario.trim() !== '' &&
               this.password.trim() !== '' &&
               this.confirmar_password.trim() !== '') {
               this.btn_siguiente = true;
            } else {
               this.btn_siguiente = false;
            }
         },
         async guardar_info() {
            if (this.nombre.trim() === '' || this.usuario.trim() === '' || this.password.trim() === '' || this.confirmar_password.trim() === '') {
               minix({ icon: 'warning', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })
            } else {
               // Validación del nombre de usuario
               const usuarioRegex = /^[a-z][a-z0-9]{4,}$/;


               if (!usuarioRegex.test(this.usuario)) {
                  atexto({
                     titulo: 'Incumplimientos', cuerpo: 'El nombre de usuario debe cumplir con los siguientes requisitos: <br><br>' +
                        '- Mínimo 5 caracteres <br>' +
                        '- No puede contener mayúsculas <br>' +
                        '- No puede iniciar con un número <br>' +
                        '- No puede contener espacios', icono: 'warning'
                  })

                  return;
               }

               // Validación de contraseña con expresión regular
               const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[^\s]{8,}$/;

               if (!passwordRegex.test(this.password)) {
                  atexto({
                     titulo: 'Incumplimientos', cuerpo: 'La contraseña debe cumplir con los siguientes requisitos: <br><br>' +
                        '- Mínimo 8 caracteres <br>' +
                        '- Al menos una letra mayúscula <br>' +
                        '- Al menos un número <br>' +
                        '- Al menos un caracter especial (!@#$%^&*) <br>' +
                        '- No debe contener espacios', icono: 'warning'
                  })
                  return;
               }

               if (this.password.trim() === this.confirmar_password.trim()) {
                  let f = {
                     nombre: this.nombre.trim().toUpperCase(),
                     usuario: this.usuario.trim().toLowerCase(),
                     password: this.password.trim()
                  }

                  this.set_usuario_datos_principales(f)
                  this.$emit('siguiente')
               } else {
                  minix({ icon: 'warning', mensaje: 'Las contraseñas son diferentes', tiempo: 3000 })
               }
            }
         },
         recuperarDatosDeVuex() {
            // Verificar si existen datos en Vuex
            if (this.objeto_usuario && this.objeto_usuario.datos_principales) {
               const datos = this.objeto_usuario.datos_principales;

               // Asignar valores si existen
               if (datos.nombre) this.nombre = datos.nombre;
               if (datos.usuario) this.usuario = datos.usuario;
               if (datos.password) {
                  this.password = datos.password;
                  this.confirmar_password = datos.password;
               }

               // Validar campos después de recuperar datos
               this.validarCampos();
            }
         },
         ...mapMutations(['set_usuario_datos_principales'])
      },
      watch: {
         nombre() {
            this.validarCampos();
         },
         usuario() {
            this.validarCampos();
         },
         password() {
            this.validarCampos();
         },
         confirmar_password() {
            this.validarCampos();
         }
      },
      mounted() {
         // Recuperar datos de Vuex al montar el componente
         this.recuperarDatosDeVuex();

         // Validar campos al cargar el componente
         this.validarCampos();
      }
   }
</script>

<style></style>